import React, { useEffect, useContext, useState } from 'react'
import { Link } from "react-router-dom"
import oilCover from '../components/layout/assets/oilCover.png'
import porscheCover911 from '../components/layout/assets/porsche911.jpg'
import ProductContext from '../context/products/ProductContext'
import RelatedCard from '../components/RelatedCard';
import HomeIcons from '../components/HomeIcons';
import Brands from '../components/Brands'
import { Helmet } from 'react-helmet';


function Home() {

  const {
    relatedProducts,
    fetchRelatedProducts
  } = useContext(ProductContext)

  useEffect(() => {
    fetchRelatedProducts()
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const images = [oilCover];

  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  const goToNextSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrevSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToNextSlide();
    }, 15000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const pageTitle = "Добредојдовте на нашата онлајн продавница за масла, филтри, авто делови и адитиви.";
  const pageDescription = "Купете висококвалитетни оригинални производи за автомобилски сервис. Погледнете ги нашите препорачани производи и брендови.";
  const pageKeywords = "онлајн продавница, автомобилски сервис, масла, адитиви, моторни масла, авто делови, мал сервис";


  return (
    <>

      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
      </Helmet>

      <div className="relative w-full">
        <div className="relative h-[30vh] overflow-hidden rounded-lg md:h-[50vh] lg:h-[70vh]">
          {images.map((image, index) => (
            <div
              key={index}
              className={`transition-all duration-700 ease-in-out absolute w-full h-full ${activeIndex === index ? 'opacity-100' : 'opacity-0'
                }`}
              style={{
                transition: 'opacity 0.7s ease-in-out',
              }}
            >
              <img
                src={image}
                className="absolute block w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                alt={`Slide ${index + 1}`}
              />
              {index === 0 && (
                <div>
                  <div className="absolute top-1 md:top-1/3 text-center ml-8 mr-8 md:ml-4 md:mr-4 ">
                    <h1 className="text-lg md:text-2xl lg:text-4xl xl:text-5xl font-extrabold mb-4 text-white z-20 ">
                      Добредојдовте на нашата специјализирана онлајн продавница за Мал Сервис
                    </h1>
                  </div>
                  <div className="absolute z-30 flex top-[70%] md:top-[70%] -translate-x-1/2  rtl:space-x-reverse left-1/2">
                    <Link to='/oils'>
                      <button className="btn btn-secondary btn-xs md:btn cursor-pointer">Погледни ги продуктите</button>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="absolute z-30 flex -translate-x-1/2 space-x-3 rtl:space-x-reverse bottom-5 left-1/2">
          {images.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`w-3 h-3 rounded-full ${activeIndex === index ? 'bg-gray-800' : 'bg-white'}`}
              aria-label={`Slide ${index + 1}`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>

        <button
          type="button"
          className="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
          onClick={goToPrevSlide}
        >
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
            <svg
              className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4" />
            </svg>
            <span className="sr-only">Previous</span>
          </span>
        </button>

        <button
          type="button"
          className="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
          onClick={goToNextSlide}
        >
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
            <svg
              className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
            </svg>
            <span className="sr-only">Next</span>
          </span>
        </button>
      </div>
      <div>
        <h2 className='text-2xl font-bold mt-[10%] text-center mb-10'>Препорачани производи</h2>
        <div
          className='flex flex-wrap gap-12 justify-center'
        >
          {!relatedProducts || relatedProducts.length === 0 ? (
            <p>Нема поврзани производи за прикажување</p>
          ) : relatedProducts.map((prod) => (
            <div key={prod.id}>
              <RelatedCard key={prod.id} item={prod} />
            </div>
          ))
          }
        </div>
      </div>
      <div>
        <h2 className="text-2xl font-bold mt-[5%] text-center mb-4">Брендови</h2>
        <Brands />
      </div>
      <HomeIcons />
    </>

  )
}

export default Home
